import { Link } from "react-router-dom";
import useSEO from '@/hooks/useSEO';

export default function XmReview() {
  useSEO({
    /* @replace:xm-review-title */

    title: 'Compare XM 2026 | XM Broker Alternatives & Comparisons',
    /* @replace:xm-review-description */

    description: 'Explore all XM broker comparisons in one place. Review how XM compares with different forex brokers and discover key differences through side-by-side comparison pages.',
    /* @replace:xm-review-keywords */

    keywords: 'Compare XM, XM broker comparison, XM vs forex brokers, XM trading comparison, forex broker analysis',
    /* @replace:xm-review-canonical */

    canonical: '/xm-review',
  });

  return (
    <div className="min-h-screen bg-bg-primary pt-24 pb-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h1 className="text-3xl md:text-5xl font-bold text-text-primary mb-4">XM Review</h1>
        <p className="text-text-secondary text-lg">Complete in-depth review of XM Broker. Coming in Phase 2.</p>
        <Link to="/" className="inline-block mt-8 px-6 py-3 bg-accent-primary text-white rounded-md hover:bg-accent-hover transition-colors">
          Back to Home
        </Link>
      </div>
    </div>
  );
}